export default __webpack_public_path__ + "static/media/NCERCPambady.5098cb03.jpg";